import { Brain, RefreshCcw, ShieldCheck, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  {
    icon: Brain,
    title: "Structured System",
    desc: "A memory, focus and learning system — not just study tips.",
  },
  {
    icon: RefreshCcw,
    title: "Better Recall",
    desc: "Build habits that bring information back when you need it.",
  },
  {
    icon: ShieldCheck,
    title: "Calm Exams",
    desc: "Walk into examinations with calm and confidence.",
  },
  {
    icon: Sparkles,
    title: "7-Day Method",
    desc: "Built by an experienced educator & mentor.",
  },
];

const IntroStrip = () => (
  <section data-testid="intro-strip-section" className="py-14 lg:py-20 bg-white border-b border-slate-100">
    <div className="max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal className="max-w-3xl mx-auto text-center">
        <p className="text-lg md:text-xl leading-relaxed text-slate-700">
          IQMIZE is a structured memory, focus and learning system for students.{" "}
          <span className="font-bold text-inavy">
            You don't need to study endlessly — you need to learn more effectively.
          </span>
        </p>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" data-testid="intro-strip-grid">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.08}>
            <div
              data-testid={`intro-strip-${item.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="h-full rounded-2xl border border-slate-200 bg-brand-light/60 p-5 lg:p-6 text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_35px_rgb(0,0,0,0.07)]"
            >
              <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-brand text-white">
                <item.icon size={22} strokeWidth={1.8} />
              </div>
              <h3 className="mt-4 text-sm lg:text-base font-extrabold text-slate-900">{item.title}</h3>
              <p className="mt-1.5 text-xs lg:text-sm leading-relaxed text-slate-600">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default IntroStrip;
